module.exports = __webpack_public_path__ + "img/business.d8f1d9bc.png";